import React from 'react'

function Footer(){
	return(
		<footer className="container">
			<hr></hr>
			<p className="text-center">&copy; さんまブログ 2024-2026 </p>
		</footer>
	);
}

export default Footer;